import { styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_CONTAINER_FIELDS_FLOATING,
  DARK_FIELDS_ON_CARD_HEADER_LINE,
  LIGHT_CONTAINER_FIELDS_FLOATING,
  LIGHT_HEADER_LINE,
} = COLORS;

export const EditProfileMediaResumeContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING,
  borderRadius: 8,
  marginTop: 10,
}));

export const EditProfileMediaResumeHeaderContainer = styled('header')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: 70,
  paddingInline: 10,

  '& svg': {
    width: 30,
  },
  '& .MuiTypography-root': {
    fontSize: '10px',
  },

  [theme.breakpoints.up('md')]: {
    height: 90,
    paddingInline: 20,
    '& svg': {
      width: '50px',
      height: '50px',
    },
    '& .MuiTypography-root': {
      fontSize: '14px',
    },
  },
  borderBottom: `1px solid ${theme.palette.type === 'dark' ? DARK_FIELDS_ON_CARD_HEADER_LINE : LIGHT_HEADER_LINE}`,
}));

export const EditProfileResumeProgressContainer = styled('div')(() => ({
  flex: 1,
  textAlign: 'end',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'end',
  gap: 20,
}));

export const EditProfileResumeContentListContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gap: 20,
  padding: '20px 10px',
  '& .MuiTypography-root': {
    fontSize: '10px',
  },
  [theme.breakpoints.up('md')]: {
    padding: '20px',
    '& .MuiTypography-root': {
      fontSize: '14px',
    },
  },
}));

export const EditProfileResumeHiddenContentText = styled('p')(({ theme }) => ({
  paddingInline: 20,
  display: 'block',
  borderBottom: `1px solid ${theme.palette.type === 'dark' ? DARK_FIELDS_ON_CARD_HEADER_LINE : LIGHT_HEADER_LINE}`,
  paddingBottom: 10,
}));
